
import React from 'react';
import styles from './Loader.module.scss';
const Loader = () => {
   return (
       <div className={styles.pageWrapper}>
           <div class={styles.pageLoader}>Loading...</div>
       </div>
   )
};

export default Loader;
